"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SelectionButton = require("./SelectionButton");
Object.keys(_SelectionButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SelectionButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SelectionButton[key];
    }
  });
});